export default __webpack_public_path__ + "static/media/arrow-back.8518d58f.svg";